import React, { useEffect } from 'react';
import FacilityPage from '../components/FacilityPage';

const FamilyLounge: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);
  return (
    <FacilityPage
      title="Family Lounge"
      description="Our family lounge is designed to be a place where families can come together and create memories that will last a lifetime. With comfortable seating, kid-friendly amenities, and a warm atmosphere, it's the perfect space for family gatherings, celebrations, and quality time together."
      features={[
        "Family-friendly environment",
        "Comfortable seating arrangements",
        "Kid-friendly menu options",
        "Safe and secure atmosphere",
        "Perfect for family celebrations",
        "Spacious layout for large groups",
        "Entertainment options for children"
      ]}
      images={["/images/facilities/family-lounge.jpg"]}
    />
  );
};

export default FamilyLounge;